import { useEffect } from "react";

import { REALTIME_POSTGRES_CHANGES_LISTEN_EVENT } from "@supabase/supabase-js";
import getSupabaseBrowserClient from "./use-supabase-browser";

export function useSubscription<Data = any>(
  callback: (
    payload: any,
    event: REALTIME_POSTGRES_CHANGES_LISTEN_EVENT
  ) => void,
  identifier: string,
  table: string
) {
  const supabase = getSupabaseBrowserClient();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const subscription = supabase
      .channel(`realtime:${identifier}:${table}`)
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table },
        (payload) =>
          callback(payload, REALTIME_POSTGRES_CHANGES_LISTEN_EVENT.INSERT)
      )
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table },
        (payload) =>
          callback(payload, REALTIME_POSTGRES_CHANGES_LISTEN_EVENT.UPDATE)
      )
      .on(
        "postgres_changes",
        { event: "DELETE", schema: "public", table },
        (payload) =>
          callback(payload, REALTIME_POSTGRES_CHANGES_LISTEN_EVENT.DELETE)
      )
      .subscribe((status, error) => {});
    return () => {
      subscription.unsubscribe();
    };
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
}
